import * as React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

const TextBox = () => {
  return (
    <Box
      sx={{
        backgroundColor: "rgba(128, 128, 128, 0.7)", // Transparent grey
        borderRadius: 2,
        padding: 3,
        mb: 3,
        mx: "auto",
        maxWidth: "800px",
        textAlign: "center",
      }}
    >
      <Typography
        variant="h6"
        sx={{
          color: "#4caf50", // Green color
          fontWeight: "bold",
          textShadow: "1px 1px 2px rgba(0, 0, 0, 0.5)",
        }}
      >
        Finish and submit the form to qualify for our free consultation offer
      </Typography>
    </Box>
  );
};

export default TextBox;
